import script from "./GISPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GISPage.vue?vue&type=script&lang=ts&setup=true"

import "./GISPage.vue?vue&type=style&index=0&id=08556660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08556660"]])

export default __exports__